<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Form-->
<div class="Main2Col">
	<!--Code-->
	<label>Code:</label>
	<input [(ngModel)]="Code" class="form-control" type="text" />

	<!--Desc-->
	<label>Description:</label>
	<input [(ngModel)]="Desc" class="form-control" type="text" />

	<!--User Level CBO-->
	<label>User Level:</label>
	<select disabled="true" class="form-control" name="SelectedUserLevel" [(ngModel)]="SelectedUserLevel">
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstUserLevels" [ngValue]="o.UserLevelID">
			{{ o.UserLevelDesc }}
		</option>
	</select>

	<!--Available to All Schools CHK-->
	<label *ngIf="AllowDistrictGroups == true" for="AllSchools">Available to all Schools:</label>
	<input *ngIf="AllowDistrictGroups == true" id="AllSchools" disabled="true" [(ngModel)]="AllSchools" class="form-control" type="checkbox" />
</div>

<!--Buttons-->
<div class="Center TopMargin">
	<button class="btn btn-primary" (click)="onUpdate()">Update</button>
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
